import { formatShortThaiDate } from '../../utils/dateUtils';

export const formatThaiDate = (date: Date) => {
  const thaiDays = [
    'อาทิตย์',
    'จันทร์',
    'อังคาร',
    'พุธ',
    'พฤหัสบดี',
    'ศุกร์',
    'เสาร์',
  ];
  const thaiMonths = [
    'มกราคม',
    'กุมภาพันธ์',
    'มีนาคม',
    'เมษายน',
    'พฤษภาคม',
    'มิถุนายน',
    'กรกฎาคม',
    'สิงหาคม',
    'กันยายน',
    'ตุลาคม',
    'พฤศจิกายน',
    'ธันวาคม',
  ];

  const day = thaiDays[date.getDay()];
  const dateNum = date.getDate();
  const month = thaiMonths[date.getMonth()];
  const year = date.getFullYear() + 543; // Convert to Buddhist Era

  return `วัน${day}ที่ ${dateNum} ${month} ${year}`;
};

export const getDisplayTodayDate = () => {
  const currentDate = new Date();
  return formatThaiDate(currentDate);
};

export const getShortTodayDate = () => {
  const currentDate = new Date();
  return formatShortThaiDate(currentDate)
}

export const deepEqual = <T>(array1: T[], array2: T[]) => {
  if (array1.length !== array2.length) return false;
  for (let i = 0; i < array1.length; i++) {
    if (JSON.stringify(array1[i]) !== JSON.stringify(array2[i])) return false;
  }
  return true;
};